<aside class="rc-signed-out__panel" aria-hidden="true">
  <svg class="rc-signed-out__crown" viewBox="0 0 54 30" xmlns="http://www.w3.org/2000/svg">
    <!-- Easter egg (started from onCrownClick): a narrow golden glint glides slowly over the crown, like light over
         polished gold, fading in and out. It only travels over the part of the crown that is not behind the app
         screens. -->
    <defs>
      <linearGradient
        id="rc-signed-out-shine"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="54"
        y2="18"
        gradientTransform="translate(-19 0)">
        <stop offset="0.38" stop-color="#f2be3c" stop-opacity="0" />
        <stop offset="0.45" stop-color="#f2be3c" stop-opacity="0.45" />
        <stop offset="0.5" stop-color="#ffe7a1" stop-opacity="0.9" />
        <stop offset="0.55" stop-color="#f2be3c" stop-opacity="0.45" />
        <stop offset="0.62" stop-color="#f2be3c" stop-opacity="0" />
        <animateTransform
          #shine
          id="rcSignedOutShine"
          attributeName="gradientTransform"
          type="translate"
          from="-19 0"
          to="9 0"
          [attr.dur]="shineDuration"
          begin="indefinite"
          calcMode="spline"
          keyTimes="0;1"
          keySplines="0.45 0 0.55 1" />
      </linearGradient>
    </defs>
    <path [attr.d]="crownPath" (mousedown)="onCrownMouseDown($event)" (click)="onCrownClick()" />
    <path class="rc-signed-out__crown-shine" [attr.d]="crownPath" [attr.fill]="shineFill" opacity="0">
      <animate
        attributeName="opacity"
        values="0;1;1;0"
        keyTimes="0;0.2;0.8;1"
        [attr.dur]="shineDuration"
        begin="rcSignedOutShine.begin" />
    </path>
  </svg>
  @if (isDesk) {
    <p class="rc-signed-out__wordmark"><b>CROWN</b>DESK</p>
    <div class="rc-signed-out__intro">
      <p class="rc-signed-out__intro-title">{{ "SIGNED_OUT_CROWNDESK_INTRO" | translate }}</p>
      <ul class="rc-signed-out__features">
        <li>
          <span class="rc-signed-out__feature-icon">
            <svg viewBox="0 0 24 24">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4zM3 6h18M16 10a4 4 0 0 1-8 0" />
            </svg>
          </span>
          {{ "SIGNED_OUT_CROWNDESK_FEATURE_ORDERS" | translate }}
        </li>
        <li>
          <span class="rc-signed-out__feature-icon">
            <svg viewBox="0 0 24 24">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8zM14 2v6h6M16 13H8M16 17H8" />
            </svg>
          </span>
          {{ "SIGNED_OUT_CROWNDESK_FEATURE_INVOICES" | translate }}
        </li>
        <li>
          <span class="rc-signed-out__feature-icon">
            <svg viewBox="0 0 24 24">
              <path
                d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16zM3.3 7 12 12l8.7-5M12 22V12" />
            </svg>
          </span>
          {{ "SIGNED_OUT_CROWNDESK_FEATURE_PRODUCTS" | translate }}
        </li>
      </ul>
    </div>
  } @else {
    <div class="rc-signed-out__brand">
      <div class="rc-signed-out__eyebrow">Royal Crown</div>
      <p class="rc-signed-out__wordmark"><b>CROWNBASE</b><span> | NXT</span></p>
    </div>
    <div class="rc-signed-out__shots-frame">
      <div class="rc-signed-out__shots">
        <img
          class="rc-signed-out__shot rc-signed-out__shot--back"
          src="assets/images/signed-out/crownbase-delivery.png"
          alt="" />
        <img
          class="rc-signed-out__shot rc-signed-out__shot--front"
          src="assets/images/signed-out/crownbase-orders.png"
          alt="" />
      </div>
    </div>
    <div class="rc-signed-out__edge"></div>
    <div class="rc-signed-out__fade"></div>
  }
  <div class="rc-signed-out__sheen"></div>
</aside>

<main class="rc-signed-out__main">
  <div class="rc-signed-out__column">
    <div class="rc-signed-out__lang">
      @for (lang of languages; track lang) {
        <button type="button" [attr.aria-pressed]="language() === lang" (click)="useLanguage(lang)">
          {{ lang.toUpperCase() }}
        </button>
      }
    </div>

    <div class="rc-signed-out__content">
      @if (!isDesk) {
        <span [class]="'rc-signed-out__badge rc-signed-out__badge--' + reason">{{ config.appName }}</span>
      }
      <h1 class="rc-signed-out__title">{{ text.title | translate }}</h1>
      <p class="rc-signed-out__body">{{ body | translate: { app: config.appName } }}</p>
      <button
        kendoButton
        themeColor="primary"
        type="button"
        class="rc-signed-out__login"
        [disabled]="loggingIn()"
        (click)="logIn()">
        {{ text.button | translate }}
      </button>
      @if (isDesk) {
        <p class="rc-signed-out__hint">{{ "SIGNED_OUT_CROWNDESK_NO_ACCESS" | translate }}</p>
      } @else {
        <p class="rc-signed-out__hint">
          <span class="rc-signed-out__ms" aria-hidden="true">
            <i style="background: #f25022"></i><i style="background: #7fba00"></i><i style="background: #00a4ef"></i
            ><i style="background: #ffb900"></i>
          </span>
          <span>{{ "SIGNED_OUT_MICROSOFT_HINT" | translate }}</span>
        </p>
      }
    </div>

    <footer class="rc-signed-out__foot">
      <span>© {{ year }} Royal Crown</span>
      @if (isDesk) {
        <a href="https://www.royalcrown.be" target="_blank" rel="noopener">royalcrown.be</a>
      } @else {
        @if (config.helpUrl) {
          <a class="rc-signed-out__help" [href]="config.helpUrl">{{ "SIGNED_OUT_HELP_IT" | translate }}</a>
        } @else {
          <span class="rc-signed-out__help">{{ "SIGNED_OUT_HELP_IT" | translate }}</span>
        }
      }
    </footer>
  </div>
</main>
